import { useHttp } from "hooks/useHttp";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  getBrandSettings,
  updateBrandSettings,
} from "api/brands/brandSettings";
import addNotification from "helpers/notify";
import Select from "react-select";
import { superAdminGetCompanies } from "api/users/superAdminGetCompanies";
import { setBrands } from "actions/user";
import { getBrands } from "api/brands/getBrands";
import { useHttpWithCache } from "hooks/useHtthWithCache";
import CustomChannelsModal from "./customChannels";

export default function BrandSettingsView({ brandToEdit }) {
  const dispatch = useDispatch();
  const milestonesRedux = useSelector((s) => s.user.milestones);
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const brandsRedux = useSelector((s) => s.user.brands);
  const [recentBrandSettings, setRecenetBrandSettings] = useState(false);
  const [customChannelsOpen, setCustomChannelsOpen] = useState(false);
  const [include2DElements, setInclude2DElements] = useState(false);
  const [includeMiscellaneous, setIncludeMiscellaneous] = useState(false);
  const [milestones, setMilestones] = useState([]);
  const [selectedMilestone, setSelectedMilstone] = useState(null);
  const parentBrandOptions = brandsRedux?.map((i) => ({
    label: i.name,
    value: i._id,
  }));

  const { brandSettingsLoading, request: getBrandSettings } = useHttp({
    requestCallback: (brandID) => getBrandSettings(brandID),
    onLoad: async (response) => {
      setRecenetBrandSettings(response);
      handle2DElementCheckbox(response?.include2DElements);
      handleMiscellaneousElementCheckbox(response?.includeMiscellaneous);
      const milestoneOptions = milestonesRedux?.map((i) => ({
        label: i.key,
        value: i._id,
      }));

      const settingMileStone = milestoneOptions.find(
        (mileStoneItem) => mileStoneItem?.value === response?.milestone
      );

      setSelectedMilstone(settingMileStone);
      setMilestones(milestoneOptions);
    },
    onError: (res) => {
      addNotification("something went wrong", "danger");
    },
  });

  const handle2DElementCheckbox = (value = false) => {
    setInclude2DElements(value);
  };

  const handleMiscellaneousElementCheckbox = (value = false) => {
    setIncludeMiscellaneous(value);
  };

  const hanldeBrandSettingApiRequest = () => {
    const payload = {
      _id: recentBrandSettings?._id,
      companyId: userInfoRedux?.company,
      brandId: recentBrandSettings?.brandId,
      milestone: selectedMilestone?.value,
      includeMiscellaneous: includeMiscellaneous,
      include2DElements: include2DElements,
    };
    updateBrandSetting(payload);
  };

  const { loading: updateLoading, request: updateBrandSetting } = useHttp({
    requestCallback: (data) => updateBrandSettings(data),
    onLoad: (res) => {
      addNotification(
        "Brand export settings successfully updated",
        "success"
      );
      if (userInfoRedux?.superAdmin) {
        getAdminBrandsAPI();
      } else {
        getBrandsAPI();
      }
    },
    onError: (res) => {
      console.log("Error**", res);
      addNotification("Something went wrong", "danger");
    },
  });

  const {
    adminBrandsLoading,
    adminBrandsError,
    request: getAdminBrandsAPI,
  } = useHttpWithCache({
    requestCallback: () => superAdminGetCompanies(),
    reduxSetter: (data) => {
      dispatch(
        setBrands(
          data?.company_brands?.find(
            (item) => item?._id === userInfoRedux?.company
          )?.brands
        )
      );
    },
    reduxReset: () => {
      dispatch(setBrands(null));
    },
    reduxCash: {
      brands: brandsRedux,
    },
    allowToCash: false,
  });

  const {
    loading,
    error,
    request: getBrandsAPI,
  } = useHttpWithCache({
    requestCallback: () => getBrands(),
    reduxSetter: (data) => {
      dispatch(setBrands(data?.brands));
    },
    reduxReset: () => {
      dispatch(setBrands(null));
    },
    reduxCash: {
      brands: brandsRedux,
    },
    allowToCash: false,
  });

  useEffect(() => {
    getBrandSettings(brandToEdit?.brandBrandSettings);
  }, []);

  return (
    <div className="p-3">
      <div
        className="header-btn bg-white text-bid border-bid rounded-lg h6 mb-0 cursor-pointer mr-1"
        onClick={() => setCustomChannelsOpen(true)}
        title="Manage external community / forum / Q&A platforms this brand engages on"
      >
        <span className="f-14">
          <i className="fa fa-globe mr-2" />
          Custom Channels
        </span>
      </div>
      <CustomChannelsModal
        isOpen={customChannelsOpen}
        onClose={() => setCustomChannelsOpen(false)}
        brandId={brandToEdit?._id}
        brandName={brandToEdit?.title}
      />
      <div
        className="header-btn bg-bid text-white border-bid rounded-lg h6 ml-auto mb-0 cursor-pointer mr-1 export-save-btn"
        onClick={hanldeBrandSettingApiRequest}
      >
        <span className="f-14">
          {updateLoading ? (
            <i className="fa fa-spinner small-spinner mr-2" />
          ) : (
            <i className="fa fa-save mr-2 "></i>
          )}
          Save
        </span>
      </div>
      <div className="border rounded-3 bg-white p-3 pb-4">
        <div className="form-group-div">
          <div>
            <label className="inter pl-2">Status</label>
            <Select
              options={milestones}
              value={selectedMilestone}
              onChange={(options) => setSelectedMilstone(options)}
            />
          </div>
        </div>
      </div>

      <div className="border rounded-3 bg-white p-3 pb-4 mt-3">
        <label className="inter pl-2 f-14">
          Additional export configuration
        </label>
        <div>
          <div className="form-check">
            <input
              className="form-check-input squared-checkbox"
              type="checkbox"
              value=""
              id="flexCheckDefault"
              checked={includeMiscellaneous}
              onChange={(e) =>
                handleMiscellaneousElementCheckbox(e?.target?.checked)
              }
            />
            <label
              className="form-check-label f-14 inter"
              htmlFor="flexCheckDefault"
            >
              Include rooms spaces and miscellaneous items
            </label>
          </div>
          <div className="form-check mt-3">
            <input
              className="form-check-input squared-checkbox"
              type="checkbox"
              value=""
              id="flexCheckChecked"
              checked={include2DElements}
              onChange={(e) => handle2DElementCheckbox(e?.target?.checked)}
            />
            <label
              className="form-check-label inter f-14"
              htmlFor="flexCheckChecked"
            >
              Include 2D Elements
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
